<template>
  <div class="padding-sm">

    <h2 class="notice-title">{{ title }}</h2>
    <p class="notice-time">{{ time }}</p>
    <div class="notice-content" v-html="content"></div>

  </div>
</template>

<script>
import {msgOne} from "@/api/common";
export default {
  name: "noticeDetail", data() {
    return {
      id: '',
      title: '',
      time: '',
      content: '',
    };
  },
  created() {

    this.id = this.$route.query.id
    this.getDetail();
  },
  methods: {
    async getDetail() {
      let _data = await msgOne(this.id);
      this.title = _data.data.msg_title
      this.time = _data.data.add_time
      this.content = _data.data.msg_content
    },

  }
}
</script>

<style scoped lang="scss">
.notice-title{
  text-align: center;
  font-size: 28px;
  color: #272730;
  line-height: 56px;
}
.notice-time{
  text-align: center;
  color: #999;
  line-height: 40px;
}
.notice-content{
  padding :10px 0;
  border-top: 1px solid #e6e6e6;
  line-height: 200%;
}
</style>